export {
  tabsBaseContainerStyles,
  tabsBaseItemStyles,
  tabsBaseListStyles
} from "./tabs-base-styles"
export type { TabsBaseOrientation } from "./tabs-base-styles"
